import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../services/theme.service';

interface PasswordRule {
  key: string;
  regex: RegExp;
}

@Component({
  selector: 'app-password-strength',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './password-strength.component.html',
  styleUrl: './password-strength.component.scss',
})
export class PasswordStrengthComponent {
  readonly isDark = inject(ThemeService).isDark;
  @Input() password = '';

  rules: PasswordRule[] = [
    { key: 'PASSWORD_STRENGTH.AT_LEAST_6_CHARACTERS', regex: /^.{6,}/ },
    { key: 'PASSWORD_STRENGTH.AN_UPPERCASE_CHARACTER', regex: /[A-Z]/ },
    { key: 'PASSWORD_STRENGTH.A_LOWERCASE_CHARACTER', regex: /[a-z]/ },
    { key: 'PASSWORD_STRENGTH.A_NUMBER', regex: /[0-9]/ },
  ];

  isValid(rule: PasswordRule): boolean {
    return rule.regex.test(this.password);
  }
}
